if (!customElements.get('challenge-grid')) {
  customElements.define(
    'challenge-grid',
    class ChallengeGrid extends HTMLElement {
      connectedCallback() {
        this.squares = Array.from(this.querySelectorAll('[data-cg-square]'));
        this.count = this.querySelector('[data-cg-count]');
        this.track = this.querySelector('[data-cg-track]');
        this.fill = this.querySelector('[data-cg-fill]');
        this.complete = this.querySelector('[data-cg-complete]');
        this.resetButton = this.querySelector('[data-cg-reset]');

        this.key = this.dataset.storageKey;
        this.persist = this.dataset.persist === 'true';
        this.total = this.squares.length;

        if (!this.total) return;

        this.done = this.read();
        this.squares.forEach((square, index) => {
          if (this.done.has(index)) square.classList.add('is-done');
          square.setAttribute('aria-pressed', this.done.has(index) ? 'true' : 'false');
          square.addEventListener('click', () => this.toggle(square, index));
        });

        if (this.resetButton) {
          this.resetButton.addEventListener('click', () => this.clear());
        }

        this.update({ animate: false });
      }

      toggle(square, index) {
        const isDone = this.done.has(index);

        if (isDone) {
          this.done.delete(index);
          square.classList.remove('is-done', 'is-just-done');
        } else {
          this.done.add(index);
          square.classList.add('is-done', 'is-just-done');
          square.addEventListener('animationend', () => square.classList.remove('is-just-done'), { once: true });
        }

        square.setAttribute('aria-pressed', isDone ? 'false' : 'true');
        this.save();
        this.update({ animate: true });
      }

      clear() {
        this.done.clear();
        this.squares.forEach((square) => {
          square.classList.remove('is-done', 'is-just-done');
          square.setAttribute('aria-pressed', 'false');
        });
        this.save();
        this.update({ animate: true });
      }

      update({ animate } = { animate: true }) {
        const done = this.done.size;
        const percent = this.total ? (done / this.total) * 100 : 0;

        if (this.count) this.count.textContent = done;
        if (this.fill) this.fill.style.width = `${percent}%`;
        if (this.track) this.track.setAttribute('aria-valuenow', done);
        if (this.resetButton) this.resetButton.hidden = done === 0;

        if (this.complete) {
          const finished = done === this.total;
          if (finished && this.complete.hidden) {
            this.complete.hidden = false;
            if (animate) this.complete.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          } else if (!finished) {
            this.complete.hidden = true;
          }
        }
      }

      read() {
        if (!this.persist) return new Set();

        try {
          const stored = JSON.parse(window.localStorage.getItem(this.key) || '[]');
          if (!Array.isArray(stored)) return new Set();
          return new Set(stored.filter((index) => Number.isInteger(index) && index >= 0 && index < this.total));
        } catch (error) {
          return new Set();
        }
      }

      save() {
        if (!this.persist) return;

        try {
          if (this.done.size) {
            window.localStorage.setItem(this.key, JSON.stringify(Array.from(this.done)));
          } else {
            window.localStorage.removeItem(this.key);
          }
        } catch (error) {
          // Storage can be unavailable (private mode, quota) — progress simply isn't remembered.
        }
      }
    }
  );
}
